var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"s-vstack"},[_c('Block',{attrs:{"title":"Online Store","items":_vm.items}},[_c('Form')],1),_c('Catering'),_c('Links')],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }